import {Inject, ModelEvents, Singleton,} from "@denishussar/html5-game-engine";
import {CellModel, CellStateEnum, LockCellModel,} from "../Models/LockCellModel";

@Singleton
export class GameLogic {
    constructor(
        @Inject private _model: LockCellModel,
        @Inject private _modelEvents: ModelEvents
    ) {
    }

    public reset(): void {
        this._model.cells = [];
        this._model.cellsCount = 13;
        this._model.cellsCountOpened = [3, 5];
        this._model.complete = false;

        for (let i = 0; i < 13; i++) {
            this._model.cells.push(new CellModel(i));
        }
    }

    public closeCell(model: CellModel): boolean {
        model.state = CellStateEnum.close;
        if (this._isAllCellsClosed()) {
            return true;
        }
        return false;
    }

    public randomizeCloseCells(model: LockCellModel): void {
        for (let i = 0; i < model.cells.length; i++) {
            model.cells[i].state = CellStateEnum.close;
        }

        const countOpened = this._getRandomInt(model.cellsCountOpened[0], model.cellsCountOpened[1]);

        for (let i = 0; i <= countOpened; i++) {
            const randomInd = this._getRandomInt(0, model.cells.length - 1);
            model.cells[randomInd].state = CellStateEnum.open;
        }
    }

    private _getRandomInt(min: number, max: number) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    private _isAllCellsClosed() {
        return this._model.cells.every((cell) => {
            return cell.state === "close";
        });
    }
}
